"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "masainas": {
    "006d0ca4": [{
      "hkey": "f18e15a7",
      "slug": "masainas",
      "name": "Masainas",
      "primary": true,
      "skipSearch": false
    }],
    "is-crobeddus": [{
      "hkey": "f18e15a7",
      "slug": "masainas",
      "name": "Masainas",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a034bde0": [{
      "hkey": "f18e15a7",
      "slug": "masainas",
      "name": "Masainas",
      "primary": true,
      "skipSearch": false
    }],
    "is-lois": [{
      "hkey": "f18e15a7",
      "slug": "masainas",
      "name": "Masainas",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "078952a5": [{
      "hkey": "f18e15a7",
      "slug": "masainas",
      "name": "Masainas",
      "primary": true,
      "skipSearch": false
    }],
    "su-pranu-o-medau-sabiu": [{
      "hkey": "f18e15a7",
      "slug": "masainas",
      "name": "Masainas",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;